import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { Router } from '@angular/router';
import { ClipBoardService } from '../../../services/clipboard.service'
import { ServerService } from 'src/app/services/server.service';
// import { UserInfoModalComponent } from "./user-info-modal/user-info-modal.component";
import { UserInfoModalComponent } from '../../users/user-info-modal/user-info-modal.component';
import { UserTokenComponent } from '../../users/user-token/user-token.component';
// import { ResetPasswordComponent } from 'src/app/resetPassword/resetPassword.component';
import { ResetPasswordComponent } from '../../users/reset-password/reset-password.component';
import { SuccessfulResetComponent } from '../../users/successful-reset/successful-reset.component';
import { UserEditModalComponent } from '../../users/user-edit-modal/user-edit-modal.component';
import { PermissionModalComponent } from '../../users/permission-modal/permission-modal.component';

@Component({
    selector: 'client-info-modal',
    templateUrl: './client-info-modal.component.html',
    styleUrls: ['./client-info-modal.component.scss']
})
export class ClientInfoModalComponent implements OnInit {
    authToken = localStorage.getItem("token")
    public userInfo = JSON.parse(localStorage.getItem("userInfo"));
    client: any = {}
    displayedColumns: string[] = ['position', 'id', 'name'];
    displayedColumnsClient: string[] = ['position', 'id', 'name','status','active','actions'];
    userInfoModalComponent: MatDialogRef<UserInfoModalComponent>;
    userTokenComponent:MatDialogRef<UserTokenComponent>
    resetPasswordComponent:MatDialogRef<ResetPasswordComponent>
    successfulResetComponent:MatDialogRef<SuccessfulResetComponent>
    userEditModalComponent:MatDialogRef<UserEditModalComponent>
    permissionModalComponent:MatDialogRef<PermissionModalComponent>
    constructor(
        private router: Router,
        private clipBoardService: ClipBoardService,
        private dialogRef: MatDialogRef<ClientInfoModalComponent>,
        private serverService:ServerService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private data
    ) {
        this.client = data
    }

    ngOnInit() {
    }
    makeUserAdmin(user, event) {
        let body = {
          id: user.id,
          org_admin: event.checked,
        };
        this.serverService
          .updateUserOrganistationAdminStatus(body, this.authToken)
          .subscribe(
            (data) => {
              if (body.org_admin) {
                this.clipBoardService.showMessgeInText(
                  "User updated to Admin Successfully",
                  "success-snackbar"
                );
              } else {
                this.clipBoardService.showMessgeInText(
                  "User updated to Not Admin Successfully",
                  "success-snackbar"
                );
              }
            },
            (err) => {
              this.clipBoardService.checkServerError(err, this.authToken);
            }
          );
      }
      disableUser(element, event) {
        let body = {
          id: element.id,
          active: event.checked,
        };
        this.serverService.disbaleUser(body, this.authToken).subscribe(
          (data) => {
            if (body.active) {
              this.clipBoardService.showMessgeInText(
                "User Enabled Successfully",
                "success-snackbar"
              );
            } else {
              this.clipBoardService.showMessgeInText(
                "User Disabled Successfully",
                "success-snackbar"
              );
            }
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
          }
        );
      }
    close() {
        this.dialogRef.close();
    }

    viewProject(element) {
        if (!element.disable) {
            localStorage.setItem("projectInfo", JSON.stringify(element))
            this.clipBoardService.select('/page/project')
            this.clipBoardService.isActive('/page/project')
            this.router.navigate(["/page/project/leads"])
            this.dialogRef.close()
        } else {
            this.clipBoardService.showMessgeInText("Project is disable, Cannot show", "error-snackbar")
        }
    }

    viewUser(element) {
        //console.log(element)
        this.clipBoardService.userName = element.name
        this.clipBoardService.select('/page/users')
        this.clipBoardService.isActive('/page/users')
        this.router.navigate(["/page/users"])
        this.dialogRef.close()
    }
    viewVendor(element) {
        //console.log(element)
        this.clipBoardService.vendorName = element.name
        this.clipBoardService.select('/page/vendors')
        this.clipBoardService.isActive('/page/vendors')
        this.router.navigate(["/page/vendors"])
        this.dialogRef.close()
    }
    viewProjectDetail(id:any,element:any){
        localStorage.setItem("projectInfo", JSON.stringify(element));
        // this.router.navigate([`page/project/${id}`])
        this.router.navigate([]).then(result => { window.open('/page/project/leads/' + id, '_blank'); });
    }
    userData(lead) {
        console.log(lead)
        this.serverService.getUserById(lead, this.authToken).subscribe(
          (data) => {
            this.userInfoModalComponent = this.dialog.open(UserInfoModalComponent, {
              hasBackdrop: true,
              disableClose: false,
              autoFocus: true,
              width: "500px",
              panelClass: "cdk-overlay-panel-right-side",
              data: data,
            });
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
          }
        );
      }
      getUserToken(element) {
        this.serverService.getUserToken(element.id, this.authToken).subscribe(
          (data) => {
            let body = {
              userDetail: element,
              auth_token: data.auth_token,
            };
            this.userTokenComponent = this.dialog.open(UserTokenComponent, {
              hasBackdrop: true,
              disableClose: false,
              autoFocus: true,
              width: "400px",
              data: body,
            });
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
          }
        );
      }
      resetPassword(element,client?:any) {
        // console.log(client)
        element['member_of'] = client.name
        this.resetPasswordComponent = this.dialog.open(ResetPasswordComponent, {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "500px",
          panelClass: "cdk-overlay-panel-right-side",
          data: element,
        });
        this.resetPasswordComponent.afterClosed().subscribe((result) => {
          // console.log(result)
          if (result != undefined) {
            element["newPassword"] = result["password"];
            this.successfulResetComponent = this.dialog.open(
              SuccessfulResetComponent,
              {
                hasBackdrop: true,
                disableClose: false,
                autoFocus: true,
                width: "500px",
                // panelClass: 'cdk-overlay-panel-right-side',
                data: element,
              }
            );
          }
        });
      }
      editUserDetails(element) {
        this.userEditModalComponent = this.dialog.open(UserEditModalComponent, {
          hasBackdrop: true,
          disableClose: false,
          autoFocus: true,
          width: "500px",
          panelClass: "cdk-overlay-panel-right-side",
          data: element,
        });
        this.userEditModalComponent.afterClosed().subscribe((result) => {
          // console.log("hi",result)
          // element["newPassword"] = result["password"]
          //   this.successfulResetComponent = this.dialog.open(SuccessfulResetComponent, {
          //     hasBackdrop: true,
          //     disableClose: false,
          //     autoFocus: true,
          //     width: '500px',
          //     // panelClass: 'cdk-overlay-panel-right-side',
          //     data: element
          //   });
          // })
          if (result != undefined) {
            // this.getAllUsers();
          }
        });
      }
      permission(element) {
        this.serverService.getUserById(element, this.authToken).subscribe(
          (data) => {
            this.permissionModalComponent = this.dialog.open(
              PermissionModalComponent,
              {
                hasBackdrop: true,
                disableClose: false,
                autoFocus: true,
                width: "500px",
                panelClass: "cdk-overlay-panel-right-side",
                data: data,
              }
            );
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
          }
        );
      }
      verifyPhone(element) {
        let body = {
          phone_verified: !element.phone_verified,
        };
        this.serverService.verifyNumber(element.id, body, this.authToken).subscribe(
          (data) => {
            if (body.phone_verified) {
              this.clipBoardService.showMessgeInText(
                "Phone Verified Successfully",
                "success-snackbar"
              );
            } else {
              this.clipBoardService.showMessgeInText(
                "Phone Unverified Successfully",
                "error-snackbar"
              );
            }
            element.phone_verified = !element.phone_verified;
          },
          (err) => {
            this.clipBoardService.checkServerError(err, this.authToken);
          }
        );
      }
    
      verifyEmail(element) {
        let body = {
          email_verified: !element.email_verified,
        };
        this.serverService
          .virtualVerifyEmail(element.id, body, this.authToken)
          .subscribe(
            (data) => {
              if (body.email_verified) {
                this.clipBoardService.showMessgeInText(
                  "Email Verified Successfully",
                  "success-snackbar"
                );
              } else {
                this.clipBoardService.showMessgeInText(
                  "Email Unverified Successfully",
                  "error-snackbar"
                );
              }
              element.email_verified = !element.email_verified;
            },
            (err) => {
              this.clipBoardService.checkServerError(err, this.authToken);
            }
          );
      }
}

